import { useMutation, useQueryClient } from 'react-query';
import { reviews } from '../constants/Keys';

import { postImage as postReview } from '../global/helpers';

export const usePostReview = (url) => {
  const queryClient = useQueryClient();

  const handlePost = async (data) => {
    await postReview(url, data);
  };

  return useMutation(handlePost, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(reviews);
    },
  });
};
